import React from 'react';
import RetroactivePulse from './RetroactivePulse';
import Pulse from './Pulse';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import PulseCTA from './PulseCTA';
import useSettingsService from 'components/hooks/useSettingsService';
import useDoraFeatureFlags from '../../hooks/useDoraFeatureFlags';
import TeamSpaceHeader from './team-space';
import useTeamSpace from './team-space/useTeamSpace';
import { ITERATION_STATES } from 'state/selectors/iterations-picker';
import TeamSpaceEmptyState from './team-space/TeamSpaceEmptyState';

const PulseRouter = props => {
  const { currentIteration, selectedTeamProject, isTeamLicense } = props;
  const { getSettingOrDefinitionValue } = useSettingsService();
  const { isAllControbutorsTeamSelected } = useDoraFeatureFlags();

  const isTeamPMConfigurationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.teamPMConfigurationEnabled
  });
  const teamSpace = useTeamSpace();

  const isRetroactive = teamSpace.isEnabled
    ? teamSpace.isRetroactive
    : currentIteration?.state === ITERATION_STATES.CLOSE &&
      selectedTeamProject?.pdt_project_id &&
      isTeamPMConfigurationEnabled;

  const shouldShowPulseCta = isAllControbutorsTeamSelected && isTeamLicense;

  if (shouldShowPulseCta) return <PulseCTA />;

  return (
    <>
      {teamSpace.isEnabled && <TeamSpaceHeader teamSpace={teamSpace} />}
      {teamSpace.emptyStateType ? (
        <TeamSpaceEmptyState emptyStateType={teamSpace.emptyStateType} />
      ) : isRetroactive ? (
        <RetroactivePulse {...props} {...teamSpace.overrideProps} />
      ) : (
        <Pulse {...props} {...teamSpace.overrideProps} />
      )}
    </>
  );
};

export default PulseRouter;
